<div style="background-color: #ffffff" class="paddedContent">
  <app-filterable-table
    #customersTable
    [tableView]="tableView"
    [options]="options"
    (initialized)="handleTableInitialized()"
    (selectedRecord)="handleCustomerSelected($event)"
  />
</div>
